import React, { useState, createContext, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';

import Actions from '../../../store/ducks/appointments';

const NewAppointmentContext = createContext();

const NewAppointmentProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [newAppointmentInfos, setNewAppointmentInfos] = useState({
    timeTableId: null,
    columnDate: null,
    professionalId: null,
    meetingId: null,
    contact: '',
    mainDoubt: '',
  });

  const sendNewAppointment = useCallback(() => {
    const {
      timeTableId,
      columnDate,
      professionalId,
      meetingId,
      contact,
      mainDoubt,
    } = newAppointmentInfos;

    dispatch(
      Actions.sendAppointment(
        timeTableId,
        columnDate,
        professionalId,
        meetingId,
        contact,
        mainDoubt,
      ),
    );
  }, [dispatch, newAppointmentInfos]);

  return (
    <NewAppointmentContext.Provider
      value={{
        newAppointmentInfos,
        setNewAppointmentInfos,
        sendNewAppointment,
      }}
    >
      {children}
    </NewAppointmentContext.Provider>
  );
};

function useNewAppointment() {
  const context = useContext(NewAppointmentContext);
  if (!context) {
    throw new Error(
      'useNewAppointment must be used within an NewAppointmentProvider',
    );
  }
  return context;
}

export { NewAppointmentProvider, useNewAppointment };
